export default __webpack_public_path__ + "static/media/panels.19f5d29d.svg";